import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAx7nPTJpuWtfCVA97i-UHTw2sUx6GqUcs",
    authDomain: "slack-clone-111220.firebaseapp.com",
    projectId: "slack-clone-111220",
    storageBucket: "slack-clone-111220.appspot.com",
    messagingSenderId: "944800528108",
    appId: "1:944800528108:web:b29f19db96cf80f00657c9",
    measurementId: "G-0S81HYJSHT"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
